import { IAdminGlobalData } from "@interfaces/screens/admin-data.interface";
import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { ILang } from "@models/*";
import { IProaService, ProaService} from "@services/proyecta/proa-form.service";

export class AdminGlobalPresenter extends BasePresenter<IAdminGlobalData> {
  private currentLang: ILang;
  private _service: IProaService;

  constructor(view: IAdminGlobalData) {
    super(view);
    this.currentLang = useSelector(this.context.sessionStore.selectLang);
    this._service = new ProaService();
  }

    public async initialize(){        
        const data = await this._service.getAllGlobalAdministration(this.currentLang.label);
        this.view.state.setData(data);
        this.dispatcherUnsetSetLoading();        
    }

  public getAdminListByApp(appId: number) {
    const items = this.view.state.data.lists.filter(
      (x: any) => x.aplicacionesId[0] == appId
    );
    const sections = this.view.state.data.sections;
    const dataSource = sections.map((x: any) => {
      return {
        key: x.Title,
        items: items.filter((item: any) => item.Admin_SeccionesId == x.Id),
      };
    });
    return {
      dataSource: dataSource,
      height: "100%",
      width: "100%",
      grouped: true,
      collapsibleGroups: true,
      focusStateEnabled: false,
    };
  }
}
